import { CmpsScorecardSubHeaderData } from '@cmps/ng-kit';

import { RootConfig } from '../scorecard/core/config.scorecard.model';
import { HistoryPosition } from '../scorecard/pulse-widget/general/history-position.model';
import { Scorecard } from '../scorecard/scorecard-next.model';
import {
    PeriodTypeShallow,
    ScorecardDataDto,
    ScorecardDto,
} from '../scorecard/scorecard.model';
import { User } from '../user/user.model';
import { PeriodType } from '../widget/date-range.widget.model';

import { ScorecardData } from './my-scorecard.model';

// TODO unify after main scorecard state switches to objects
export type ScorecardHistory = {
    [periodTypeId in PeriodType]?: ScorecardDto[];
};
export interface ScorecardDataset {
    [key: string /* periodType-scorecardId */]: ScorecardDataDto;
}
export interface ScorecardState {
    pending: {
        reload?: boolean;
        listData?: boolean;
        hasData?: boolean;
    };

    user?: User;
    rootConfig?: RootConfig;
    periodTypes?: PeriodTypeShallow[];
    scorecardHistory: ScorecardHistory;
    scorecardDataset: ScorecardDataset;

    selectedPeriodType?: PeriodTypeShallow; // TODO this might move
    selectedScorecardHistory?: ScorecardDto[];
    selectedScorecard?: Scorecard;

    // TODO replace with json config option
    showScorecardDetail?: boolean;
    yourTeamExpanded?: boolean;
    yourTeamEnabled?: boolean;
    historyPos?: HistoryPosition;
    scorecardData?: ScorecardData;
    periodOptions?: CmpsScorecardSubHeaderData[];
}

export const defaultState = (): ScorecardState => ({
    pending: {},
    scorecardHistory: {},
    scorecardDataset: {},
});
